var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "USA@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-831.000000, -866.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "USA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.000000, 796.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,47.61 L64.77,47.61 C67.0722252,47.4259507 69.1134298,46.058836 70.16,44 L1.6,44 C2.64839458,46.0617137 4.69410636,47.4293099 7,47.61 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91,40.38 L0.91,41.72 C0.997644306,42.5115386 1.22803494,43.2806368 1.59,43.99 L70.14,43.99 C70.5019651,43.2806368 70.7323557,42.5115386 70.82,41.72 L70.82,40.38 L0.91,40.38 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    x: 0.91,
    y: 36.77,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.91,
    y: 33.16,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    x: 0.91,
    y: 29.55,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.91,
    y: 25.94,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    x: 0.91,
    y: 22.33,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.91,
    y: 18.72,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    x: 0.91,
    y: 15.11,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0.91,
    y: 11.49,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ED5565",
    x: 0.91,
    y: 7.88,
    width: 69.92,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,7.88 L70.83,6.54 C70.7435416,5.74503797 70.5131203,4.97244886 70.15,4.26 L1.6,4.26 C1.23687975,4.97244886 1.00645843,5.74503797 0.92,6.54 L0.92,7.88 L70.83,7.88 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76,0.66 L7,0.66 C4.69777484,0.844049262 2.65657024,2.21116403 1.61,4.27 L70.16,4.27 C69.1116054,2.20828634 67.0658936,0.840690135 64.76,0.66 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.09,25.94 L34.09,0.66 L7,0.66 C3.82619503,0.914083785 1.27947966,3.38527876 0.93,6.55 L0.93,25.94 L34.09,25.94 Z",
    id: "Shape",
    fill: "#4A89DC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "5.02 3.72 4.75 4.56 3.87 4.56 4.58 5.07 4.31 5.91 5.02 5.39 5.73 5.91 5.46 5.07 6.17 4.56 5.29 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "5.02 7.96 4.75 8.8 3.87 8.8 4.58 9.32 4.31 10.15 5.02 9.64 5.73 10.15 5.46 9.32 6.17 8.8 5.29 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "5.02 12.2 4.75 13.04 3.87 13.04 4.58 13.56 4.31 14.4 5.02 13.88 5.73 14.4 5.46 13.56 6.17 13.04 5.29 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "5.02 16.45 4.75 17.28 3.87 17.28 4.58 17.8 4.31 18.64 5.02 18.12 5.73 18.64 5.46 17.8 6.17 17.28 5.29 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "5.29 21.52 5.02 20.69 4.75 21.52 3.87 21.52 4.58 22.04 4.31 22.88 5.02 22.36 5.73 22.88 5.46 22.04 6.17 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "7.51 5.84 7.24 6.68 6.36 6.68 7.07 7.2 6.8 8.03 7.51 7.51 8.23 8.03 7.96 7.2 8.67 6.68 7.79 6.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "7.51 10.08 7.24 10.92 6.36 10.92 7.07 11.44 6.8 12.27 7.51 11.76 8.23 12.27 7.96 11.44 8.67 10.92 7.79 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "7.51 14.33 7.24 15.16 6.36 15.16 7.07 15.68 6.8 16.52 7.51 16 8.23 16.52 7.96 15.68 8.67 15.16 7.79 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "7.79 19.4 7.51 18.57 7.24 19.4 6.36 19.4 7.07 19.92 6.8 20.76 7.51 20.24 8.23 20.76 7.96 19.92 8.67 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.01 3.72 9.74 4.56 8.86 4.56 9.57 5.07 9.3 5.91 10.01 5.39 10.72 5.91 10.45 5.07 11.16 4.56 10.28 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.01 7.96 9.74 8.8 8.86 8.8 9.57 9.32 9.3 10.15 10.01 9.64 10.72 10.15 10.45 9.32 11.16 8.8 10.28 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.01 12.2 9.74 13.04 8.86 13.04 9.57 13.56 9.3 14.4 10.01 13.88 10.72 14.4 10.45 13.56 11.16 13.04 10.28 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.01 16.45 9.74 17.28 8.86 17.28 9.57 17.8 9.3 18.64 10.01 18.12 10.72 18.64 10.45 17.8 11.16 17.28 10.28 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "10.28 21.52 10.01 20.69 9.74 21.52 8.86 21.52 9.57 22.04 9.3 22.88 10.01 22.36 10.72 22.88 10.45 22.04 11.16 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "12.5 5.84 12.23 6.68 11.35 6.68 12.06 7.2 11.79 8.03 12.5 7.51 13.22 8.03 12.95 7.2 13.66 6.68 12.78 6.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "12.5 10.08 12.23 10.92 11.35 10.92 12.06 11.44 11.79 12.27 12.5 11.76 13.22 12.27 12.95 11.44 13.66 10.92 12.78 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "12.5 14.33 12.23 15.16 11.35 15.16 12.06 15.68 11.79 16.52 12.5 16 13.22 16.52 12.95 15.68 13.66 15.16 12.78 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "12.78 19.4 12.5 18.57 12.23 19.4 11.35 19.4 12.06 19.92 11.79 20.76 12.5 20.24 13.22 20.76 12.95 19.92 13.66 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15 3.72 14.73 4.56 13.85 4.56 14.56 5.07 14.29 5.91 15 5.39 15.71 5.91 15.44 5.07 16.15 4.56 15.27 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15 7.96 14.73 8.8 13.85 8.8 14.56 9.32 14.29 10.15 15 9.64 15.71 10.15 15.44 9.32 16.15 8.8 15.27 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15 12.2 14.73 13.04 13.85 13.04 14.56 13.56 14.29 14.4 15 13.88 15.71 14.4 15.44 13.56 16.15 13.04 15.27 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15 16.45 14.73 17.28 13.85 17.28 14.56 17.8 14.29 18.64 15 18.12 15.71 18.64 15.44 17.8 16.15 17.28 15.27 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15.27 21.52 15 20.69 14.73 21.52 13.85 21.52 14.56 22.04 14.29 22.88 15 22.36 15.71 22.88 15.44 22.04 16.15 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "17.49 5.84 17.22 6.68 16.34 6.68 17.05 7.2 16.78 8.03 17.49 7.51 18.21 8.03 17.93 7.2 18.65 6.68 17.77 6.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "17.49 10.08 17.22 10.92 16.34 10.92 17.05 11.44 16.78 12.27 17.49 11.76 18.21 12.27 17.93 11.44 18.65 10.92 17.77 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "17.49 14.33 17.22 15.16 16.34 15.16 17.05 15.68 16.78 16.52 17.49 16 18.21 16.52 17.93 15.68 18.65 15.16 17.77 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "17.77 19.4 17.49 18.57 17.22 19.4 16.34 19.4 17.05 19.92 16.78 20.76 17.49 20.24 18.21 20.76 17.93 19.92 18.65 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "19.99 3.72 19.72 4.56 18.84 4.56 19.55 5.07 19.28 5.91 19.99 5.39 20.7 5.91 20.43 5.07 21.14 4.56 20.26 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "19.99 7.96 19.72 8.8 18.84 8.8 19.55 9.32 19.28 10.15 19.99 9.64 20.7 10.15 20.43 9.32 21.14 8.8 20.26 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "19.99 12.2 19.72 13.04 18.84 13.04 19.55 13.56 19.28 14.4 19.99 13.88 20.7 14.4 20.43 13.56 21.14 13.04 20.26 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "19.99 16.45 19.72 17.28 18.84 17.28 19.55 17.8 19.28 18.64 19.99 18.12 20.7 18.64 20.43 17.8 21.14 17.28 20.26 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "20.26 21.52 19.99 20.69 19.72 21.52 18.84 21.52 19.55 22.04 19.28 22.88 19.99 22.36 20.7 22.88 20.43 22.04 21.14 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "22.48 5.84 22.21 6.68 21.33 6.68 22.04 7.2 21.77 8.03 22.48 7.51 23.2 8.03 22.92 7.2 23.64 6.68 22.76 6.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "22.48 10.08 22.21 10.92 21.33 10.92 22.04 11.44 21.77 12.27 22.48 11.76 23.2 12.27 22.92 11.44 23.64 10.92 22.76 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "22.48 14.33 22.21 15.16 21.33 15.16 22.04 15.68 21.77 16.52 22.48 16 23.2 16.52 22.92 15.68 23.64 15.16 22.76 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "22.76 19.4 22.48 18.57 22.21 19.4 21.33 19.4 22.04 19.92 21.77 20.76 22.48 20.24 23.2 20.76 22.92 19.92 23.64 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "24.98 3.72 24.71 4.56 23.83 4.56 24.54 5.07 24.27 5.91 24.98 5.39 25.69 5.91 25.42 5.07 26.13 4.56 25.25 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "24.98 7.96 24.71 8.8 23.83 8.8 24.54 9.32 24.27 10.15 24.98 9.64 25.69 10.15 25.42 9.32 26.13 8.8 25.25 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "24.98 12.2 24.71 13.04 23.83 13.04 24.54 13.56 24.27 14.4 24.98 13.88 25.69 14.4 25.42 13.56 26.13 13.04 25.25 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "24.98 16.45 24.71 17.28 23.83 17.28 24.54 17.8 24.27 18.64 24.98 18.12 25.69 18.64 25.42 17.8 26.13 17.28 25.25 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "25.25 21.52 24.98 20.69 24.71 21.52 23.83 21.52 24.54 22.04 24.27 22.88 24.98 22.36 25.69 22.88 25.42 22.04 26.13 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "27.47 5.84 27.2 6.68 26.32 6.68 27.03 7.2 26.76 8.03 27.47 7.51 28.19 8.03 27.91 7.2 28.63 6.68 27.75 6.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "27.47 10.08 27.2 10.92 26.32 10.92 27.03 11.44 26.76 12.27 27.47 11.76 28.19 12.27 27.91 11.44 28.63 10.92 27.75 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "27.47 14.33 27.2 15.16 26.32 15.16 27.03 15.68 26.76 16.52 27.47 16 28.19 16.52 27.91 15.68 28.63 15.16 27.75 15.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "27.75 19.4 27.47 18.57 27.2 19.4 26.32 19.4 27.03 19.92 26.76 20.76 27.47 20.24 28.19 20.76 27.91 19.92 28.63 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "29.53 5.07 29.26 5.91 29.97 5.39 30.68 5.91 30.41 5.07 31.12 4.56 30.24 4.56 29.97 3.72 29.7 4.56 28.82 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "29.97 7.96 29.7 8.8 28.82 8.8 29.53 9.32 29.26 10.15 29.97 9.64 30.68 10.15 30.41 9.32 31.12 8.8 30.24 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "29.97 12.2 29.7 13.04 28.82 13.04 29.53 13.56 29.26 14.4 29.97 13.88 30.68 14.4 30.41 13.56 31.12 13.04 30.24 13.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "29.97 16.45 29.7 17.28 28.82 17.28 29.53 17.8 29.26 18.64 29.97 18.12 30.68 18.64 30.41 17.8 31.12 17.28 30.24 17.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "30.24 21.52 29.97 20.69 29.7 21.52 28.82 21.52 29.53 22.04 29.26 22.88 29.97 22.36 30.68 22.88 30.41 22.04 31.12 21.52"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa2X);
export default __webpack_public_path__ + "static/media/USA@2x.17baaddc96bd0a712fd44f455ed04230.svg";
export { ForwardRef as ReactComponent };